import React from "react";

import moment from "moment";
import { toast } from "react-toastify";

import { convertUtcToLocal } from "../../../../../../Common/utils/dateUtils";
import { useAccessStatus } from "../../../../../../grace-period/hooks/useAccessStatus";
import { normalizeEnvReportPathList } from "../../../Preview/envCoaPreviewHelper";

import { ReactComponent as PDFIcon } from "../../../../../../../assets/images/environment/pdfIcon.svg";

export default function FileCard({ file, onPreview }) {
  const { areResultsLocked } = useAccessStatus();
  const s3Paths = normalizeEnvReportPathList(file.s3_report_path);
  const fileName = s3Paths[0] ? s3Paths[0].split("/").pop() : "";
  const reportType = file.report_type || "";

  const handlePreviewFile = () => {
    if (areResultsLocked) {
      return;
    }
    if (!s3Paths.length) {
      if (reportType === "partial") {
        toast.error("Failed to preview Partial Report");
      } else {
        toast.error("Unable to preview, no valid file path for this report!");
      }
      return;
    }
    onPreview(file);
  };

  return (
    <div
      className={`env-report-history-file-card${areResultsLocked ? " env-report-history-file-card--locked" : ""}`}
      onClick={handlePreviewFile}
      role="button"
      tabIndex={areResultsLocked ? -1 : 0}
      onKeyDown={(event) => {
        if (areResultsLocked) {
          return;
        }
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          handlePreviewFile();
        }
      }}
      aria-label={fileName ? `Preview ${fileName}` : "Preview report"}
      aria-disabled={areResultsLocked}
    >
      <div className="pdf-icon-path">
        <PDFIcon width={14} height={14} />
        <span>{fileName}</span>
      </div>
      <div className="file-card-info">
        {(file.report_type && file.report_type === "partial") && <span className="file-card-type">{file.report_type}</span>}
        <span className="file-card-date">
          {moment(new Date(convertUtcToLocal(file.received_on))).format("DD MMM YYYY")}
        </span>
      </div>
    </div>
  );
}
